/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { MetricValueResponseDto } from './MetricValueResponseDto';
import {
    MetricValueResponseDtoFromJSON,
    MetricValueResponseDtoFromJSONTyped,
    MetricValueResponseDtoToJSON,
    MetricValueResponseDtoToJSONTyped,
} from './MetricValueResponseDto';

/**
 * 
 * @export
 * @interface MetricValuesPaginationResponseDto
 */
export interface MetricValuesPaginationResponseDto {
    /**
     * List of metric values
     * @type {Array<MetricValueResponseDto>}
     * @memberof MetricValuesPaginationResponseDto
     */
    data: Array<MetricValueResponseDto>;
    /**
     * Pagination information
     * @type {PaginationDto}
     * @memberof MetricValuesPaginationResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the MetricValuesPaginationResponseDto interface.
 */
export function instanceOfMetricValuesPaginationResponseDto(value: object): value is MetricValuesPaginationResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function MetricValuesPaginationResponseDtoFromJSON(json: any): MetricValuesPaginationResponseDto {
    return MetricValuesPaginationResponseDtoFromJSONTyped(json, false);
}

export function MetricValuesPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricValuesPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MetricValueResponseDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function MetricValuesPaginationResponseDtoToJSON(json: any): MetricValuesPaginationResponseDto {
    return MetricValuesPaginationResponseDtoToJSONTyped(json, false);
}

export function MetricValuesPaginationResponseDtoToJSONTyped(value?: MetricValuesPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(MetricValueResponseDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

